import { GitBranch, Repeat, Layers, Compass, Trophy, Award, Swords, ListOrdered } from 'lucide-react';

export const FORMAT_ICONS = { GitBranch, Repeat, Layers, Compass, Trophy, Award, Swords, ListOrdered };
